import { createColorClasses } from "@/theme/colors";
import { IconProps } from "@/types/icons";
import clsx from "clsx";

export const Clock = ({
  width = 24,
  height = 24,
  className,
  color = "primary",
  fillColor = "#0066CC",
  onClick,
  decorative = false,
  ariaLabel = "Clock",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(className, classes)}
      width={width}
      height={height}
      onClick={onClick}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2812 20C4.7584 20 0.28125 15.5228 0.28125 10C0.28125 4.47715 4.7584 0 10.2812 0C12.9334 0 15.477 1.05357 17.3523 2.92893C19.2277 4.8043 20.2812 7.34784 20.2812 10C20.2812 15.5228 15.8041 20 10.2812 20ZM10.7812 3V10.5H5.28125V9.5H9.78125V3H10.7812ZM10.2812 1C15.2518 1 19.2812 5.02944 19.2812 10C19.2812 14.9706 15.2518 19 10.2812 19C5.31069 19 1.28125 14.9706 1.28125 10C1.28125 5.02944 5.31069 1 10.2812 1Z"
        fill={fillColor}
      />
    </svg>
  );
};
